export enum SmsTemplateType {
    Verification = 'verification',
    Login = 'login',
    Invitation = 'invitation',
    MfaChallenge = 'mfaChallenge',
}